import { AppEnvironment, MessagingResource } from '@internal/open-catalog';
import { useMemo, useState } from 'react';
import { CardData, ParkingLotCards, ParkingLotMessageReprocessor } from './components/parkinglot';
import React from 'react';
import { SystemEntity } from '@backstage/catalog-model';

function extractParkingLots(resources: MessagingResource[], environment: AppEnvironment): string[] {
  return resources
    .filter(r => r.spec.environment === environment)
    .reduce((acc, r) => {
      if (r.spec.topology.parkingLot?.name) {
        return [...acc, r.spec.topology.parkingLot?.name];
      }
      return acc;
    }, [] as string[])
}

export interface SystemMessagingMonitoringPageProps {
  resources: MessagingResource[],
  className?: string,
  system: SystemEntity
}

export const SystemMessagingMonitoringPage = ({ resources, className, system }: SystemMessagingMonitoringPageProps) => {

  const dev: AppEnvironment = 'development';
  const stg: AppEnvironment = 'staging';
  const prd: AppEnvironment = 'production';

  const [selectedItem, setSelectedItem] = useState<CardData | undefined>(undefined);
  const [development, setDevelopment] = useState<CardData>(useMemo(() => (
    {
      title: 'DEVELOPMENT',
      subtitle: 'Parking Lot',
      queues: extractParkingLots(resources, dev),
      env: dev,
      vhost: 'development'
    }
  ), [resources]));
  const [staging, setStaging] = useState<CardData>((useMemo(() => (
    {
      title: 'STAGING',
      subtitle: 'Parking Lot',
      queues: extractParkingLots(resources, stg),
      env: stg,
      vhost: 'staging'
    }
  ), [resources])));
  const [production, setProduction] = useState<CardData>((useMemo(() => (
    {
      title: 'PRODUCTION',
      subtitle: 'Parking Lot',
      queues: extractParkingLots(resources, prd),
      env: prd,
      vhost: 'production'
    }
  ), [resources])));

  const updateCardData = () => {
    if (selectedItem?.env === dev) {
      setDevelopment({
        ...development,
        queues: extractParkingLots(resources, dev)
      });
    } else if (selectedItem?.env === stg) {
      setStaging({
        ...staging,
        queues: extractParkingLots(resources, stg)
      });
    } else if (selectedItem?.env === prd) {
      setProduction({
        ...production,
        queues: extractParkingLots(resources, prd)
      });
    }
  }


  return (<>
    <ParkingLotCards dev={development} stg={staging} prd={production} onCardSelectionChanged={setSelectedItem} />
    <br />
    <ParkingLotMessageReprocessor queues={selectedItem?.queues || []} env={selectedItem?.env} system={system} onRefreshByChangingQueue={updateCardData} />
  </>);
}
